import { FieldType } from '@/features/application/types/forms';

/**
 * Maps form field types to compatible CRM field types
 * This ensures that when a form is submitted, the data can be sent to CRM without type errors
 */
export const FIELD_TYPE_COMPATIBILITY: Record<FieldType, string[]> = {
  text: ['string', 'text', 'textarea', 'url', 'id', 'reference', 'phone', 'email'],
  textarea: ['string', 'text', 'textarea', 'longtext', 'richtextarea'],
  email: ['string', 'text', 'email'],
  phone: ['string', 'text', 'phone'],
  date: ['date', 'string', 'text', 'textarea'],
  datetime: ['datetime', 'date', 'time', 'string', 'text', 'textarea'],
  checkbox: ['boolean', 'checkbox'],
  number: [
    'double',
    'currency',
    'percent',
    'int',
    'decimal',
    'number',
    'string',
    'text',
    'textarea',
  ],
  file: ['string', 'id', 'reference', 'url', 'textarea'], // File attachments in CRM
  signature: ['string', 'text', 'textarea', 'url'], // Signatures are stored as base64 or URLs
  terms: ['boolean', 'checkbox'],
  // Allow picklist form fields to map to CRM picklists OR any text-like CRM type,
  // since the submitted value is ultimately a string.
  picklist: ['picklist', 'string', 'text', 'textarea'],
  'tax-id': ['string', 'text', 'textarea'],
  'zip-code': ['string', 'text'],

  'ownership-percentage': ['double', 'percent', 'number', 'string', 'text'],
  ssn: ['string', 'text', 'textarea'],
};
